<template>
  <div
    class="taunt-message"
    :class="{
      'taunt-message--single-view': singleView,
      'taunt-message--full-panel': !singleView,
      unseen: mode === 'received' && !taunt.seen,
    }"
    @click="$emit('messageClicked', taunt)"
    @keypress.space="$emit('messageClicked', taunt)"
  >
    <div class="taunt-message__left">
      <div class="taunt-message__image">
        <img
          :src="taunt.thumbnail"
          alt="Auction Thumbnail"
        />
      </div>
    </div>
    <div class="taunt-message__right">
      <div class="taunt-message__text">
        <h6>{{ taunt.title }}</h6>
        <div class="tw-flex tw-justify-between tw-items-center tw-gap-8">
          <p v-if="mode === 'received'">
            {{ taunt.receiverMessage }}
          </p>
          <p v-if="mode === 'sent'">
            {{ taunt.senderMessage }}
          </p>
          <div class="tw-relative tw-shrink-0">
            <acv-time-counter
              v-if="mode === 'received'"
              :clock-offset="clockOffset"
              :end-time="taunt.endTime"
              @counter-ended="$emit('counterEnded', taunt.id)"
            />
            <div
              v-if="mode === 'received'"
              class="flames"
            />
          </div>
        </div>
      </div>
      <div
        v-if="mode === 'received'"
        class="taunt-message__actions"
      >
        <acv-button
          variant="tertiary"
          size="small"
          type="button"
          @click="$emit('buttonClicked', taunt.auctionId)"
        >
          Raise your bid and beat the competition!
        </acv-button>
      </div>
    </div>
    <div class="taunt-message__close">
      <acv-icon-button
        :icon-type="singleView ? 'remove' : 'close'"
        :show-tooltip="false"
        @click="$emit('closeClicked', taunt.id)"
      />
    </div>
  </div>
</template>

<script>
import { AcvButton, AcvIconButton } from '@acv/shared-vuejs';
import { mapGetters } from 'vuex';

export default {
  name: 'TauntMessage',
  components: {
    AcvButton,
    AcvIconButton,
    AcvTimeCounter: () => import('@acv/shared-vuejs').then((shared) => shared.AcvTimeCounter),
  },
  props: {
    singleView: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'received',
    },
    taunt: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      clockOffset: 'auctions/clockOffset',
    }),
  },
};
</script>

<style lang="scss" scoped>
.taunt-message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: theme('colors.white.DEFAULT');
  border-radius: 0.75rem;
  border: 1px solid theme('colors.border.base');
  word-wrap: break-word;
  position: relative;
  flex-direction: column;
  transition: all 0.2s ease-in-out;

  &__image {
    width: 106px;
    height: 106px;
    border-radius: 0.75rem;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 0.75rem;
    }
  }

  &__right {
    flex: 1;
    overflow-wrap: break-word;
  }

  &__actions {
    > * {
      width: 100%;
    }
  }

  .taunt-message__close {
    position: absolute;
    top: 0;
    right: 0;
  }

  :deep(.acv-time-counter) {
    flex-shrink: 0;
    color: theme('colors.error.dark');
    font-weight: theme('fontWeight.medium');
  }

  .flames {
    background-image: url('../../assets/flames.gif');
    background-position: center;
    background-size: cover;
    position: absolute;
    top: -25px;
    right: -5px;
    opacity: 0.7;
    height: calc(100% + 30px);
    width: calc(100% + 10px);
    will-change: opacity, transform;
    backface-visibility: visible;
    pointer-events: none;
  }

  &--single-view {
    flex-direction: row;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
    border: none;

    .taunt-message__right {
      margin: 0 0 0 1rem;
    }
  }

  &--full-panel {
    border-radius: 0.75rem;
    padding: 0;

    &.unseen {
      background: theme('colors.primary.base');
      color: theme('colors.white.DEFAULT');
    }

    .taunt-message__left {
      width: 100%;
    }

    .taunt-message__right {
      padding: 1rem;
    }

    .taunt-message__image {
      border-radius: 0.75rem 0.75rem 0 0;
      width: 100%;
      height: 124px;

      img {
        border-radius: 0.75rem 0.75rem 0 0;
        object-fit: cover;
      }
    }

    :deep(.acv-icon-button) {
      background: theme('colors.grey.base');
      border-radius: 99px;
    }
  }
}
</style>
